import { render, staticRenderFns } from "./work_field_edit.vue?vue&type=template&id=a08a37e6&scoped=true"
import script from "./work_field_edit.vue?vue&type=script&lang=js"
export * from "./work_field_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08a37e6",
  null
  
)

export default component.exports